import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import notFound from '../assets/images/notFound1.png';
import { Button } from '@mui/material';

function NotFound() {
  const navigate = useNavigate();

  const goBack = () => navigate('/');

  return (
    <div className="align-center justify-center flex-column">
      <img src={notFound} width="500px" height="500px" alt="Not found" />
      <h1>Página não encontrada</h1>
      <p>A URL que você tentou acessar não existe.</p>
      <Button
        sx={{ width: '300px', height: '40px' }}
        variant="outlined"
        color="primary"
        onClick={goBack}
      >
        Voltar para a página inicial
      </Button>
    </div>
  );
}

export default NotFound;
